///<reference path="../../employee/sections/employee.compensation.section.ts"/>
module Meevo.Plugins.Student {
    "use strict";

    /**
    * Compensation Section of Employee 
    */
    export class CompensationSection extends Meevo.Plugins.Employee.CompensationSection {
        public get auditNounForSave() {
            return Model.NounEnum.StudentCompensations;
        }
    }
}